export default __webpack_public_path__ + "0913efb29417b51ce914339078d14a66.png";